<template>
	<div v-loading="loading" class="base_scroll_page">
		<div class="b_scroller">
			<!-- 查询条件 -->
			<div class="base_inquire">
				<div class="b_item">
					<span class="b_label">账号：</span>
					<el-input v-model="search_account" class="b_inp" placeholder="账号"></el-input>
				</div>
				
				<div class="b_item">
					<span class="b_label">操作类型：</span>
					<el-select v-model="search_action" class="b_inp">
						<el-option :value="0" label="全部"></el-option>
						<el-option :value="1" label="正常操作"></el-option>
						<el-option :value="2" label="异常操作"></el-option>
					</el-select>
				</div>
				
				<div class="b_item">
					<span class="b_label">开始时间：</span>
					<el-date-picker
						v-model="search_startTime"
						:editable="false"
						placeholder="开始时间"
						type="datetime"
						value-format="yyyy-MM-dd HH:mm:ss"
						@change="handleSearchStartTimeClick"
					>
					</el-date-picker>
				</div>
				
				<div class="b_item">
					<span class="b_label">结束时间：</span>
					<el-date-picker
						v-model="search_endTime"
						:editable="false"
						placeholder="结束时间"
						type="datetime"
						value-format="yyyy-MM-dd HH:mm:ss"
						@change="handleSearchEndTimeClick"
					>
					</el-date-picker>
				</div>
				
				<el-button type="primary" @click="handleSearchClick">查询</el-button>
			</div>
			<!-- 查询条件 end -->
			
			<!-- 表格 -->
			<div class="base_table" style="margin-top: 20px;">
				<el-table
					:data="tableData"
					style="width: 100%"
				>
					<el-table-column
						prop="code"
						label="操作人账号"
					>
					</el-table-column>
					<el-table-column
						prop="name"
						label="操作人姓名"
					>
					</el-table-column>
					<el-table-column
						prop="url"
						label="路径"
					>
					</el-table-column>
					<el-table-column
						prop="ip"
						label="ip地址"
					>
					</el-table-column>
					<el-table-column
						prop="actionName"
						label="操作类型"
					>
					</el-table-column>
					<el-table-column
						prop="firm"
						label="所属机构"
					>
					</el-table-column>
					<el-table-column
						prop="creatDate"
						label="创建时间"
					>
					</el-table-column>
					<el-table-column
						width="200"
						prop="params"
						label="请求参数"
					>
					</el-table-column>
					<el-table-column
						width="200"
						prop="result"
						label="结果描述"
					>
					</el-table-column>
				</el-table>
			</div>
			<!-- 表格 end -->
			
			<!-- 页码 -->
			<div class="clear_both" style="margin-top: 20px;">
				<div class="base_pager" style="float: right;">
					<el-pagination
						layout="total, prev, pager, next, jumper"
						next-text="下一页" 
						:total="total"
						:current-page="currentPage"
						:page-size="5"
						@current-change="handlePageChange">
					</el-pagination>
				</div>
			</div>
			<!-- 页码 end -->
		</div>
	</div>	
</template>

<script>
	import BaseMethods from '../../../../../assets/js/base.js'
	import Api from '../../../../../api/index.js'
	
	export default {
		mounted () {
			this.getList();
		},
		data () {
			return {
				loading: false,
				
				tableData: [],
				total: 0,
				currentPage: 1,
				
				search_account: '',
				search_action: 0,
				search_startTime: '',
				search_endTime: ''
			}
		},
		methods: {
			/************************ @Events *******************************/
			// 切换查询时间
			handleSearchStartTimeClick () {
				this.compareSearchTime();
			},
			// 切换查询时间
			handleSearchEndTimeClick () {
				this.compareSearchTime();
			},
			// 点击查询
			handleSearchClick () {
				this.currentPage = 1;
				this.getList();
			},
			
			// 切换页码
			handlePageChange (page) {
				if (this.currentPage != page) {
					this.currentPage = page;
					this.getList();
				}
			},
			
			/************************ @Function *******************************/
			// 获取数据
			getList () {
				const that = this;
				that.loading = true;
				var requestData = {
					code: that.search_account,
					endTime: that.search_endTime,
					id: null,
					limit: 5,
					pageNum: that.currentPage,
					startTime: that.search_startTime,
					logType: that.search_action
				};
				Api.findLogUpdateTraining(requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						that.total = res.data.data.totalItems;
						that.tableData = [];
						for (var i = 0;i < res.data.data.data.length;i++) {
							var _o = res.data.data.data[i];
							that.tableData.push({
								id: _o.id,
								code: _o.optUserCode || '',
								name: _o.optUserName || '',
								url: _o.optUrl || '',
								ip: _o.optIp || '',
								actionId: _o.logType || '',
								actionName: that.mapActionToName(_o.logType),
								firm: _o.optUserEnterpriseName || '',
								creatDate: BaseMethods.formatTime(_o.createTime, 'yy-mm-dd hh:mm:ss'),
								params: _o.questionParams || '',
								result: _o.resultDetail || ''
							});
						}
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 比较开始时间和结束时间
			compareSearchTime () {
				if (this.search_startTime && this.search_endTime) {
					var startTime = new Date(this.search_startTime).getTime(),
						endTime = new Date(this.search_endTime).getTime();
					if (endTime < startTime) {
						this.search_endTime = '';
						this.$message.warning('结束时间不能小于开始时间');
					}
				}
			},
			// 把操作类型转换成名称
			mapActionToName (action) {
				var result = '';
				switch (action) {
					case 1:
						result = '正常操作';
						break;
					case 2:
						result = '异常操作';
						break;
				}
				return result;
			}
		}
	}
</script>

<style scoped>
</style>
